import React, { ReactNode } from 'react';
import { Link, Flex } from '@chakra-ui/react';
import FacebookLogo from '../../../../../utils/icons/facebookLogo';
import TwitterLogo from '../../../../../utils/icons/twitterLogo';
import InstagramLogo from '../../../../../utils/icons/instagramLogo';
import UrlIcon from '../../../../../utils/icons/urlIcon';

interface ISocialsGame {
	icon: ReactNode;
	href: string;
	isWide?: boolean;
}

export const SocialsGame = ({ icon, href, isWide = false }: ISocialsGame) => {
	return (
		<Link
			href={href}
			target="_blank"
			display="flex"
			borderRadius={isWide ? '99px' : '50%'}
		>
			<Flex
				alignItems="center"
				justify="center"
				bg="transparent"
				borderRadius={isWide ? '99px' : '50%'}
				border="1px solid #949495"
				boxSize="24px"
				width={isWide ? 'auto' : '24px'}
				paddingX={isWide ? '8px' : '0'}
			>
				{icon}
			</Flex>
		</Link>
	);
};

interface ISocialsGamePanel {
	socials: {
		facebook?: string;
		twitter?: string;
		instagram?: string;
	};
	web?: string;
}

export const SocialsGamePanel = ({ socials, web }: ISocialsGamePanel) => {
	return (
		<Flex
			gridGap="12px"
			justifyContent="flex-start"
			alignItems="center"
		>
			{socials.facebook && (
				<SocialsGame
					icon={<FacebookLogo />}
					href={socials.facebook}
				/>
			)}
			{socials.instagram && (
				<SocialsGame
					icon={<InstagramLogo />}
					href={socials.instagram}
				/>
			)}
			{socials.twitter && (
				<SocialsGame
					icon={<TwitterLogo />}
					href={socials.twitter}
				/>
			)}
			{web && (
				<SocialsGame
					isWide
					icon={<UrlIcon />}
					href={web}
				/>
			)}
		</Flex>
	);
};

export default SocialsGame;
